import { render, staticRenderFns } from "./editSocial.vue?vue&type=template&id=f13a74c0&scoped=true&lang=pug"
import script from "./editSocial.vue?vue&type=script&lang=js"
export * from "./editSocial.vue?vue&type=script&lang=js"
import style0 from "./editSocial.vue?vue&type=style&index=0&id=f13a74c0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f13a74c0",
  null
  
)

export default component.exports